/* =====================================================================
   ZaunTastisch Konfigurator — Oberfläche
   Rechenkern identisch zu zt-konfigurator-logik.js
   ===================================================================== */
(function(){
"use strict";
var ZT_DATEN=JSON.parse(document.getElementById("ztk-daten").textContent);
if(typeof ZTKonfigurator==="undefined"){console.error("ZTKonfigurator fehlt");return;}

const FELDBREITE=ZTKonfigurator.FELDBREITE_M, ZUGABE_MM=570;

const FARBEN=[
  {id:"anthrazit-ral7016",roh:"Anthrazit",name:"Anthrazit",ral:"RAL 7016",hex:"#383E42"},
  {id:"moosgruen-ral6005",roh:"Moosgrün",name:"Moosgrün",ral:"RAL 6005",hex:"#2F4538"},
  {id:"verzinkt",roh:"Verzinkt",name:"Verzinkt",ral:"feuerverzinkt",hex:"#AFB8BF"}
];
const FARB_NORM={anthrazit:"anthrazit-ral7016",ral7016:"anthrazit-ral7016",
  "moosgrün":"moosgruen-ral6005",moosgruen:"moosgruen-ral6005",ral6005:"moosgruen-ral6005",
  verzinkt:"verzinkt",fvz:"verzinkt",feuerverzinkt:"verzinkt"};

const H={matte656:"doppelstabmatte-6-5-6",matte868:"doppelstabmatte-8-6-8",
  pfosten:"4c3abb6f7c9d4c55880975c749333af0",eckpfosten:"eckpfosten60x60",
  abdeckleiste:"abdeckleiste-flach",gartentuer:"gartentuer-1flg",
  kombituer:"kombituer-1flg",multitor:"5ed3aa24699e465f91eaf466f40fbe2f"};

const TITEL={[H.matte656]:"Doppelstabmatte 6/5/6",[H.matte868]:"Doppelstabmatte 8/6/8",
  [H.pfosten]:"Zaunpfosten 60×40",[H.eckpfosten]:"Eckpfosten 60×60",
  [H.abdeckleiste]:"Abdeckleiste flach",[H.gartentuer]:"Gartentür 1-flügelig",
  [H.kombituer]:"Kombitür 1-flügelig",[H.multitor]:"Multitor 2-flügelig"};

const TOR_AUSWAHL=[{h:H.gartentuer,t:"Gartentür 1-flügelig"},
  {h:H.kombituer,t:"Kombitür 1-flügelig"},{h:H.multitor,t:"Multitor 2-flügelig"}];

/* ---------- Normalisierung + Index ---------- */
function normFarbe(v){if(v==null)return null;const k=String(v).trim().toLowerCase();return FARB_NORM[k]||k;}
function normMM(v){
  if(v==null)return null;
  if(typeof v==="number")return Math.round(v>10?v:v*1000);
  const s=String(v).trim().toLowerCase().replace(",","."),m=s.match(/([\d.]+)/);
  if(!m)return null;const z=parseFloat(m[1]);
  if(/mm/.test(s))return Math.round(z);
  if(/cm/.test(s))return Math.round(z*10);
  if(/m/.test(s))return Math.round(z*1000);
  return Math.round(z>10?z:z*1000);
}
const IDX={};
Object.keys(ZT_DATEN.varianten).forEach(function(handle){
  const tab={};
  const eintrag=ZT_DATEN.varianten[handle];
  Object.keys(eintrag.varianten).forEach(function(k){
    const t=k.split("|"),n=[normFarbe(t[0]),normMM(t[1])];
    if(t.length>2)n.push(normMM(t[2]));
    tab[n.join("|")]=Object.assign({handle:handle},eintrag.varianten[k]);
  });
  IDX[handle]=tab;
});
function finde(handle,farbe,hoehe,breite){
  const t=IDX[handle];if(!t)return null;
  const k=[normFarbe(farbe),normMM(hoehe)];
  if(breite!=null)k.push(normMM(breite));
  return t[k.join("|")]||null;
}
function werteVon(handle,pos,filter){
  const t=IDX[handle]||{},out=[];
  Object.keys(t).forEach(function(k){
    const p=k.split("|");
    if(filter&&p[0]!==filter)return;
    const v=+p[pos];if(out.indexOf(v)<0)out.push(v);
  });
  return out.sort(function(a,b){return a-b});
}

/* ---------- Zustand ---------- */
const S={modell:"6/5/6",farbe:"anthrazit-ral7016",hoehe:1430,
  laenge:10,ecken:0,leisten:false,zusatz:0,tore:[]};

const $=function(s){return document.querySelector(s)};
const euro=function(n){return n.toLocaleString("de-DE",{minimumFractionDigits:2,maximumFractionDigits:2})+" €"};
const meter=function(n){return n.toLocaleString("de-DE",{minimumFractionDigits:2,maximumFractionDigits:2})+" m"};

function matteHandle(){return S.modell==="8/6/8"?H.matte868:H.matte656}

/* ---------- Rechnen ---------- */
function rechne(){
  /* Mengen kommen ausschliesslich aus assets/zt-konfigurator.js -
     keine zweite Kopie der Formeln in der Oberflaeche. */
  const m=ZTKonfigurator.mengen({
    laenge_m:S.laenge, ecken:S.ecken, zusatzpfosten:S.zusatz,
    abdeckleisten:S.leisten,
    tore:S.tore.map(function(t){return {menge:t.menge};})
  });
  return {matten:m.matten, pfosten:m.pfosten, reg:m.pfosten_regulaer,
          eck:m.eckpfosten, leisten:m.abdeckleisten, tore:m.tore,
          effektiv:m.zaunlaenge_effektiv_m};
}

function stueckliste(){
  const m=rechne(),pos=[],fehler=[];
  function add(handle,menge,breite,hoehe,pflicht){
    if(menge<=0)return;
    const v=finde(handle,S.farbe,hoehe||S.hoehe,breite);
    if(!v){
      if(pflicht)fehler.push(TITEL[handle]+" ist in dieser Kombination nicht verfügbar.");
      return;
    }
    pos.push({handle:handle,titel:TITEL[handle]||handle,menge:menge,
      variant_id:v.variant_id,sku:v.sku,preis:parseFloat(v.price),
      bild:ZT_DATEN.bilder[handle],breite:breite});
  }
  add(matteHandle(),m.matten,null,null,true);
  add(H.pfosten,m.pfosten,null,null,true);
  add(H.eckpfosten,m.eck,null,null,true);
  add(H.abdeckleiste,m.leisten,null,null,true);
  S.tore.forEach(function(t){
    if(!t.hoehe||!t.breite)return;
    const v=finde(t.handle,S.farbe,t.hoehe,t.breite);
    if(!v){fehler.push(TITEL[t.handle]+" ist in dieser Ausführung nicht verfügbar.");return;}
    pos.push({handle:t.handle,titel:TITEL[t.handle],menge:t.menge,
      variant_id:v.variant_id,sku:v.sku,preis:parseFloat(v.price),
      bild:ZT_DATEN.bilder[t.handle],breite:t.breite,hoehe:t.hoehe});
  });
  const summe=pos.reduce(function(s,p){return s+p.preis*p.menge},0);
  return {mengen:m,positionen:pos,fehler:fehler,summe:summe};
}

/* ---------- Zeichnen ---------- */
function zeichneFarben(){
  const box=$("#ztk-farbe");box.innerHTML="";
  FARBEN.forEach(function(f){
    const hoehen=werteVon(matteHandle(),1,f.id);
    const b=document.createElement("button");
    b.type="button";b.className="ztk-kachel";
    b.setAttribute("aria-pressed",String(S.farbe===f.id));
    b.dataset.wert=f.id;
    b.innerHTML='<span class="ztk-punkt" style="background:'+f.hex+'"></span>'+
      f.name+' <span class="ztk-untertitel">'+f.ral+'</span>';
    if(!hoehen.length)b.disabled=true;
    b.onclick=function(){S.farbe=f.id;pruefeHoehe();alles()};
    box.appendChild(b);
  });
}

function zeichneHoehen(){
  const box=$("#ztk-hoehe");box.innerHTML="";
  const matte=werteVon(matteHandle(),1,S.farbe);
  const pfosten=werteVon(H.pfosten,1,S.farbe);
  matte.filter(function(h){return pfosten.indexOf(h)>=0}).forEach(function(h){
    const b=document.createElement("button");
    b.type="button";b.className="ztk-kachel ztk-mass";
    b.setAttribute("aria-pressed",String(S.hoehe===h));
    b.textContent=(h/1000).toFixed(2).replace(".",",")+" m";
    b.onclick=function(){S.hoehe=h;alles()};
    box.appendChild(b);
  });
  $("#ztk-pfostenhinweis").textContent=
    "Pfosten-Gesamtlänge "+meter((S.hoehe+ZUGABE_MM)/1000)+
    " — die Überlänge wird einbetoniert.";
}

function pruefeHoehe(){
  const matte=werteVon(matteHandle(),1,S.farbe),pf=werteVon(H.pfosten,1,S.farbe);
  const moeglich=matte.filter(function(h){return pf.indexOf(h)>=0});
  if(moeglich.indexOf(S.hoehe)<0&&moeglich.length){
    S.hoehe=moeglich.reduce(function(a,b){
      return Math.abs(b-S.hoehe)<Math.abs(a-S.hoehe)?b:a});
  }
}

function zeichneLeisten(){
  const da=!!finde(H.abdeckleiste,S.farbe,S.hoehe);
  const h=$("#ztk-leisten-huelle");
  h.dataset.aus=da?"0":"1";
  if(!da){S.leisten=false;$("#ztk-leisten").checked=false;
    $("#ztk-leisten-text").textContent="Für diese Farbe und Höhe nicht im Sortiment.";}
  else $("#ztk-leisten-text").textContent="Je Pfosten eine, am Eckpfosten zwei.";
}

function zeichneTore(){
  const box=$("#ztk-tore");box.innerHTML="";
  S.tore.forEach(function(t,i){
    const z=document.createElement("div");z.className="ztk-tor";

    const sModell=document.createElement("select");
    sModell.setAttribute("aria-label","Modell");
    TOR_AUSWAHL.forEach(function(o){
      const opt=new Option(o.t,o.h,false,o.h===t.handle);sModell.add(opt);
    });
    sModell.onchange=function(){t.handle=sModell.value;torWerte(t);alles()};

    const sH=document.createElement("select");sH.setAttribute("aria-label","Höhe");
    werteVon(t.handle,1,S.farbe).forEach(function(h){
      sH.add(new Option((h/10)+" cm",h,false,h===t.hoehe));
    });
    sH.onchange=function(){t.hoehe=+sH.value;torWerte(t,true);alles()};

    const sB=document.createElement("select");sB.setAttribute("aria-label","Breite");
    breitenFuer(t).forEach(function(b){
      sB.add(new Option((b/10)+" cm",b,false,b===t.breite));
    });
    sB.onchange=function(){t.breite=+sB.value;alles()};

    const iM=document.createElement("input");
    iM.type="number";iM.min="1";iM.max="9";iM.value=t.menge;
    iM.setAttribute("aria-label","Menge");
    iM.onchange=function(){t.menge=Math.max(1,parseInt(iM.value,10)||1);alles()};

    const weg=document.createElement("button");
    weg.type="button";weg.className="ztk-weg";weg.innerHTML="×";
    weg.setAttribute("aria-label","Tür entfernen");
    weg.onclick=function(){S.tore.splice(i,1);alles()};

    /* Sichtbare Beschriftung je Feld - aria-label allein sieht niemand. */
    function feld(beschriftung,element){
      const w=document.createElement("div");w.className="ztk-torfeld";
      const b=document.createElement("span");b.className="ztk-torlabel";
      b.textContent=beschriftung;w.appendChild(b);w.appendChild(element);return w;
    }
    z.appendChild(feld("Modell",sModell));
    z.appendChild(feld("Höhe",sH));
    z.appendChild(feld("Breite",sB));
    z.appendChild(feld("Anzahl",iM));
    z.appendChild(weg);
    box.appendChild(z);
  });
}
function breitenFuer(t){
  const tab=IDX[t.handle]||{},out=[];
  Object.keys(tab).forEach(function(k){
    const p=k.split("|");
    if(p[0]===S.farbe&&+p[1]===t.hoehe&&out.indexOf(+p[2])<0)out.push(+p[2]);
  });
  return out.sort(function(a,b){return a-b});
}
function torWerte(t,nurBreite){
  if(!nurBreite){
    const h=werteVon(t.handle,1,S.farbe);
    if(h.indexOf(t.hoehe)<0)t.hoehe=h.length?h.reduce(function(a,b){
      return Math.abs(b-S.hoehe)<Math.abs(a-S.hoehe)?b:a}):null;
  }
  const b=breitenFuer(t);
  if(b.indexOf(t.breite)<0)t.breite=b[0]||null;
}

function zeichneListe(){
  const r=stueckliste();
  const box=$("#ztk-positionen");box.innerHTML="";

  if(!r.positionen.length){
    box.innerHTML='<p class="ztk-leer">Wählen Sie eine Länge, dann erscheint hier Ihre Stückliste.</p>';
  }
  r.positionen.forEach(function(p){
    const d=document.createElement("div");d.className="ztk-pos";
    const zusatz=p.breite?(p.hoehe/10)+" × "+(p.breite/10)+" cm":
      (S.hoehe/1000).toFixed(2).replace(".",",")+" m";
    d.innerHTML=
      '<img src="'+(p.bild||"")+'" alt="" loading="lazy">'+
      '<div class="ztk-pos-text">'+
        '<div class="ztk-pos-titel">'+p.titel+'</div>'+
        '<div class="ztk-pos-meta">'+zusatz+' · '+(p.sku||"")+'</div>'+
      '</div>'+
      '<div class="ztk-pos-rechts">'+
        '<div class="ztk-pos-menge">'+p.menge+' ×</div>'+
        '<div class="ztk-pos-preis">'+euro(p.preis*p.menge)+'</div>'+
      '</div>';
    box.appendChild(d);
  });

  $("#ztk-summe").textContent=euro(r.summe);
  $("#ztk-summe-mobil").textContent=euro(r.summe);
  $("#ztk-zaunlaenge").textContent=r.mengen.matten
    ? meter(r.mengen.effektiv)+" · "+r.mengen.matten+" Felder" : "—";

  const md=$("#ztk-meldungen");md.innerHTML="";
  r.fehler.forEach(function(f){
    const p=document.createElement("p");p.className="ztk-meldung fehler";p.textContent=f;
    md.appendChild(p);
  });
  if(!r.fehler.length&&r.mengen.reg===0&&r.mengen.matten>0){
    const p=document.createElement("p");p.className="ztk-meldung info";
    p.textContent="Ecken und Tore bringen eigene Pfosten mit — gerade Pfosten werden hier nicht benötigt.";
    md.appendChild(p);
  }

  const gesperrt=r.fehler.length>0||!r.positionen.length;
  $("#ztk-warenkorb").disabled=gesperrt;
  $("#ztk-warenkorb-mobil").disabled=gesperrt;
  return r;
}

function alles(){
  document.querySelectorAll("#ztk-modell .ztk-kachel").forEach(function(b){
    b.setAttribute("aria-pressed",String(b.dataset.wert===S.modell));
  });
  zeichneFarben();zeichneHoehen();zeichneLeisten();
  S.tore.forEach(function(t){torWerte(t)});
  zeichneTore();zeichneListe();
}

/* ---------- Ereignisse ---------- */
document.querySelectorAll("#ztk-modell .ztk-kachel").forEach(function(b){
  b.onclick=function(){S.modell=b.dataset.wert;pruefeHoehe();alles()};
});
function zahl(sel,feld,min,max,dez){
  const i=$(sel);
  i.oninput=function(){
    let v=dez?parseFloat(i.value.replace(",",".")):parseInt(i.value,10);
    if(isNaN(v))v=min;
    S[feld]=Math.min(max,Math.max(min,v));zeichneListe();
  };
  i.parentNode.querySelectorAll("button").forEach(function(b){
    b.onclick=function(){
      let v=(S[feld]||0)+parseFloat(b.dataset.schritt);
      v=Math.min(max,Math.max(min,v));
      S[feld]=dez?Math.round(v*10)/10:v;
      i.value=S[feld];zeichneListe();
    };
  });
}
zahl("#ztk-laenge","laenge",0,500,true);
zahl("#ztk-ecken","ecken",0,20,false);
zahl("#ztk-zusatz","zusatz",0,99,false);
$("#ztk-leisten").onchange=function(){S.leisten=this.checked;zeichneListe()};
$("#ztk-tor-plus").onclick=function(){
  const t={handle:H.gartentuer,hoehe:null,breite:null,menge:1};
  torWerte(t);S.tore.push(t);alles();
};

function inWarenkorb(){
  const r=stueckliste();
  if(r.fehler.length||!r.positionen.length)return;
  const items=r.positionen.map(function(p){
    return {id:p.variant_id,quantity:p.menge,properties:{_konfigurator:"doppelstab"}};
  });
  if(typeof fetch==="undefined"||location.protocol==="file:"){
    alert("Warenkorb-Übergabe (Vorschau):\n\n"+
      items.map(function(i){return i.quantity+" × "+i.id}).join("\n")+
      "\n\nGesamt "+euro(r.summe));
    return;
  }
  fetch("/cart/add.js",{method:"POST",
    headers:{"Content-Type":"application/json","X-Requested-With":"XMLHttpRequest"},
    body:JSON.stringify({items:items})})
    .then(function(a){if(!a.ok)throw 0;location.href="/cart";})
    .catch(function(){
      const md=$("#ztk-meldungen");
      md.innerHTML='<p class="ztk-meldung fehler">Der Warenkorb konnte nicht befüllt werden. '+
        'Es wurde nichts übernommen — bitte erneut versuchen.</p>';
    });
}
$("#ztk-warenkorb").onclick=inWarenkorb;
$("#ztk-warenkorb-mobil").onclick=inWarenkorb;


/* ============ PDF-Ausgabe und Angebotsanfrage ============================ */

function konfigZeilen(){
  const r=stueckliste(), m=r.mengen, z=[];
  z.push(["Ausführung", matteHandle()===H.matte868?"Doppelstabmatte 8/6/8":"Doppelstabmatte 6/5/6"]);
  z.push(["Farbe", (FARBEN.filter(function(f){return f.id===S.farbe})[0]||{}).name || S.farbe || "-"]);
  z.push(["Höhe", S.hoehe?meter(S.hoehe/1000):"-"]);
  z.push(["Breite", (S.laenge||0).toString().replace(".",",")+" m  (ergibt "+m.matten+" Felder = "+
          (m.effektiv||0).toFixed(2).replace(".",",")+" m)"]);
  z.push(["Ecken", String(S.ecken||0)]);
  z.push(["Abdeckleisten", S.leisten?"ja":"nein"]);
  if(S.zusatz) z.push(["Zusätzliche Pfosten", String(S.zusatz)]);
  if(S.hoehe) z.push(["Pfosten-Gesamtlänge", meter((S.hoehe+ZUGABE_MM)/1000)+" (Überlänge zum Einbetonieren)"]);
  return z;
}

function konfigText(){
  const r=stueckliste();
  let t=konfigZeilen().map(function(p){return p[0]+": "+p[1];}).join("\n");
  t+="\n\nStückliste:\n";
  r.positionen.forEach(function(p){
    t+="  "+p.menge+" × "+p.titel+(p.hoehe?" "+p.hoehe:"")+(p.breite?" / "+p.breite:"")+
       (p.sku?" (Art.-Nr. "+p.sku+")":"")+" — "+euro(p.preis*p.menge)+"\n";
  });
  t+="\nSumme: "+euro(r.summe)+" (inkl. MwSt., zzgl. Versand)";
  return t;
}

function alsPdf(){
  const r=stueckliste();
  if(!r.positionen.length) return;
  const heute=new Date().toLocaleDateString("de-DE");
  let h='<div class="kopf"><h1>Ihre Zaun-Konfiguration</h1>'+
        '<div class="meta">ZaunTastisch · Schopsdorfer Industriestraße 8 · 39291 Genthin OT Schopsdorf'+
        ' · Telefon 039225 638288 · info@zauntastisch.de<br>Erstellt am '+heute+
        ' · Preise inkl. MwSt., zzgl. Versand · unverbindlich</div></div>';
  h+='<table><tbody>';
  konfigZeilen().forEach(function(p){
    h+='<tr><td style="width:38%"><strong>'+p[0]+'</strong></td><td>'+p[1]+'</td></tr>';
  });
  h+='</tbody></table>';
  h+='<table><thead><tr><th class="num">Menge</th><th>Artikel</th>'+
     '<th class="num">Einzelpreis</th><th class="num">Summe</th></tr></thead><tbody>';
  r.positionen.forEach(function(p){
    h+='<tr><td class="num">'+p.menge+' ×</td><td>'+p.titel+
       (p.hoehe?' '+p.hoehe:'')+(p.breite?' / '+p.breite:'')+
       (p.sku?'<br><span style="font-size:9pt;color:#666">Art.-Nr. '+p.sku+'</span>':'')+'</td>'+
       '<td class="num">'+euro(p.preis)+'</td><td class="num">'+euro(p.preis*p.menge)+'</td></tr>';
  });
  h+='</tbody></table>';
  h+='<div class="summe"><span>Gesamt</span><span>'+euro(r.summe)+'</span></div>';
  h+='<div class="fuss">Diese Zusammenstellung ist ein unverbindlicher Vorschlag auf Grundlage Ihrer '+
     'Eingaben. Maßgeblich sind die Preise im Shop zum Zeitpunkt der Bestellung. '+
     'Die Pfostenlänge enthält eine Überlänge zum Einbetonieren. '+
     'Fragen? Rufen Sie uns an: 039225 638288.</div>';
  const dr=document.getElementById("ztk-druck");
  dr.innerHTML=h;
  /* Die Druckregel blendet alle direkten Kinder von <body> aus. Der Druckblock
     muss deshalb selbst ein direktes Kind von <body> sein, sonst bleibt das
     Blatt leer, weil ein Vorfahre ausgeblendet ist. */
  if(dr.parentNode!==document.body) document.body.appendChild(dr);
  window.print();
}

function angebotOeffnen(){
  const r=stueckliste();
  if(r.fehler.length||!r.positionen.length) return;
  document.getElementById("ztk-anfrage-konfig").value=konfigText();
  document.getElementById("ztk-anfrage-vorschau").textContent=konfigText();
  const d=document.getElementById("ztk-anfrage-dialog");
  d.hidden=false;
  const f=document.getElementById("ztk-anfrage-name"); if(f) f.focus();
}
function angebotSchliessen(){ document.getElementById("ztk-anfrage-dialog").hidden=true; }

(function(){
  const pdf=document.getElementById("ztk-pdf");
  const ang=document.getElementById("ztk-angebot");
  const zu=document.getElementById("ztk-anfrage-zu");
  const dlg=document.getElementById("ztk-anfrage-dialog");
  if(pdf) pdf.onclick=alsPdf;
  if(ang) ang.onclick=angebotOeffnen;
  if(zu) zu.onclick=angebotSchliessen;
  if(dlg) dlg.addEventListener("click",function(e){ if(e.target===dlg) angebotSchliessen(); });
  document.addEventListener("keydown",function(e){ if(e.key==="Escape") angebotSchliessen(); });
  /* Bestaetigung nach dem Absenden */
  if(/contact_posted=true/.test(location.search)){
    const md=document.getElementById("ztk-meldungen");
    if(md) md.innerHTML='<p class="ztk-meldung">Ihre Anfrage ist bei uns eingegangen. '+
      'Wir melden uns mit einem Angebot.</p>';
  }
})();

alles();
})();